import React from "react";
import { ArrowUpRight, Check } from "lucide-react";
import { PRICING } from "../../data/mock";

export default function Pricing() {
  return (
    <section id="pricing" className="bg-navy px-5 md:px-8 py-20 lg:py-28">
      <div className="max-w-[1240px] mx-auto grid lg:grid-cols-2 gap-12 lg:gap-20 items-center">
        <div>
          <p className="font-mono text-[12px] uppercase tracking-[0.18em] text-lime">
            04 <span className="text-cream/40">—</span> The investment
          </p>
          <h2 className="mt-5 font-grotesk font-bold leading-[1.0] tracking-tight text-[clamp(2.25rem,5vw,4.25rem)]">
            <span className="text-cream">One location.</span>{" "}
            <span className="text-teal italic">One complete call layer.</span>
          </h2>
          <p className="mt-6 text-cream/70 text-lg leading-relaxed max-w-md">
            Start with a guided setup that translates your business rules, FAQs, and escalation path into a live call-handling experience.
          </p>
          <a
            href="#contact"
            className="group mt-8 inline-flex items-center gap-2 bg-lime text-navy font-grotesk font-semibold pl-6 pr-5 py-3.5 rounded-full hover:bg-lime-bright transition-colors"
          >
            Talk through your setup
            <ArrowUpRight className="w-4 h-4 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" />
          </a>
        </div>

        <div>
          <p className="font-mono text-[12px] uppercase tracking-[0.18em] text-cream/50">
            {PRICING.eyebrow}
          </p>

          <div className="mt-6 flex items-end gap-5 pb-6 border-b border-cream/12">
            <span className="font-grotesk font-bold text-lime leading-none text-[clamp(3rem,7vw,5rem)]">
              {PRICING.setup}
            </span>
            <span className="pb-2 text-cream/70">
              <span className="block">{PRICING.setupNote1}</span>
              <span className="block text-cream/50 text-sm">{PRICING.setupNote2}</span>
            </span>
          </div>

          <div className="mt-6 flex items-end gap-5 pb-6 border-b border-cream/12">
            <span className="font-grotesk font-bold text-lime leading-none text-[clamp(3rem,7vw,5rem)]">
              {PRICING.monthly}
            </span>
            <span className="pb-2 text-cream/70">
              <span className="block">{PRICING.monthlyNote1}</span>
              <span className="block text-cream/50 text-sm">{PRICING.monthlyNote2}</span>
            </span>
          </div>

          <ul className="mt-6 space-y-3">
            {PRICING.included.map((item) => (
              <li key={item} className="flex items-center gap-3 text-cream/90">
                <span className="w-5 h-5 rounded-full bg-lime/15 flex items-center justify-center">
                  <Check className="w-3 h-3 text-lime" strokeWidth={3} />
                </span>
                {item}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}
